import styled from 'styled-components';
import Image from '@stencil/image';
export const GuestSaysWrapDiv = styled.div(
  props => `
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  padding-left:${props.theme.spacing.large};
`,
);

export const GuestSaysOuterWrapDiv = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  flex-wrap:wrap;
  border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.large};
  width:100%;
`,
);

export const GuestSaysHeaderDiv = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  flex-wrap:wrap;
  padding: ${props.theme.spacing.large} ${props.theme.spacing.base} ${props.theme.spacing.large} ${props.theme.spacing.base};
  border-bottom: 0.1rem solid ${props.theme.colors.ash.medium};

`,
);

export const HeadertxtDiv = styled.div(
  props => `
  display:flex;
  font-size:${props.theme.font.custom(14)};
  font-weight:bold;
  flex-wrap:wrap;

`,
);

export const MainContentWrapperDiv = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  flex-wrap:wrap;
  padding: ${props.theme.spacing.large} ${props.theme.spacing.base} ${props.theme.spacing.xxsmall} ${props.theme.spacing.base};
`,
);

export const MainContentOptionsDiv = styled.div(
  props => `
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  padding-bottom: ${props.theme.spacing.large};

`,
);

export const MainContentOptionsInnerDiv = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  flex-wrap:wrap;
  width: 33%;
  margin-bottom: 10px;
  padding-right:${props.theme.spacing.xxlarge};

`,
);

export const OptionsTxtDiv = styled.div(
  props => `
  display:flex;
  flex-wrap:wrap;
  font-size:${props.theme.font.custom(14)};
  padding-bottom:${props.theme.spacing.small};

`,
);

export const RatingImgDiv = styled(Image)(
  props => `
    display: flex;
    width: 8rem
    height: 1.5rem;
    `,
);
